import React, { useEffect, useRef, useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import ComponentIdentifier from '../CommonComponent/ComponentHeader/ComponentIdentifier';
import BarcodeGenerator from './utility/BarcodeGenerator';
import BarcodePrintDialogBox from './utility/BarcodePrintDialogBox';
import ReactToPrint from 'react-to-print';

function BarcodePrintComponent(props) {
    // hooks
    const printComponentRef = useRef()
    // states
    const [barcodes, setBarcodes] = useState([])

    // form on submit
    const formOnSubmit = (e) => {
        // prevent default behaviour
        e.preventDefault()
        // element
        let barcodeTextField = document.getElementById("barcodeTextField")
        let quantityTextField = document.getElementById("barcodeQuantity")
        let productNameField = document.getElementById("productNameField")

        // set new barcode to the array
        let quantityWiseTotalBarcodeArray = []
        for (let i = 0; i < quantityTextField.value; i++) {
            quantityWiseTotalBarcodeArray.push({
                barcode: barcodeTextField.value,
                label: productNameField.value
            })
        }

        let totalBarcodes = [...barcodes, ...quantityWiseTotalBarcodeArray]
        setBarcodes(totalBarcodes)
        // clear barcode text field
        barcodeTextField.value = ""
        quantityTextField.value = ""
        productNameField.value = ""
        // alert("hi")


    }
    return (
        <>
            <Card>
                <Card.Header className="d-flex align-items-center justify-content-between">
                    {<ComponentIdentifier link_name={"store"} component_name={"Barcode"} />}
                </Card.Header>
                <Card.Body className="position-relative">
                    {/* enter barcode option */}
                    <Form onSubmit={e => formOnSubmit(e)}>
                        {/* product name field */}
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Product name</Form.Label>
                            <Form.Control id="productNameField" type="text" placeholder="Enter product name" />
                        </Form.Group>
                        {/* b-code no text field */}
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Barcode No.</Form.Label>
                            <Form.Control id="barcodeTextField" type="text" placeholder="Enter barcode no." />
                        </Form.Group>
                        {/* quantity field */}
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Quantity</Form.Label>
                            <Form.Control id="barcodeQuantity" type="text" placeholder="Enter Quantity" />
                        </Form.Group>
                        {/* submit button */}
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                        {/* clear button */}
                        <Button onClick={e => setBarcodes([])} variant="danger" className='ms-2' >
                            Clear
                        </Button>
                        {/* print button */}
                        <ReactToPrint
                            pageStyle={`@media print {@page {margin: ${.2}; size: a4;} .printDiv{width:100% !important;}}`}
                            trigger={() => {
                                // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                                // to the root node of the returned component as it will be overwritten.
                                return <Button className='btn-primary ms-3 '>Print</Button>
                            }}
                            content={() => printComponentRef.current}
                        />
                    </Form>
                </Card.Body>
            </Card>
            {/* print container */}
            <BarcodePrintDialogBox printAreaRef={printComponentRef}>
                {/* barcode generator */}
                {barcodes.map((barcode, key) => (
                    <BarcodeGenerator barcode_data={barcode} />
                ))}
            </BarcodePrintDialogBox>

        </>
    );
}

export default BarcodePrintComponent;